var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.782 27.054a1 1 0 0 0 1.003.994 1 1 0 0 0 1.004-.994v-7.573h7.417v7.573a1 1 0 0 0 1.005.994 1 1 0 0 0 1.003-.994v-8.567a1 1 0 0 0-1.004-.996H4.576L1.98 6.763a1.004 1.004 0 0 0-1.21-.735.994.994 0 0 0-.742 1.199l2.754 11.379zm19.004-8.567v8.567a1 1 0 0 0 1.003.994 1 1 0 0 0 1.005-.994v-7.573h7.418v7.573a1 1 0 0 0 1.003.994 1 1 0 0 0 1.004-.994v-8.451l2.753-11.376a.995.995 0 0 0-.742-1.2 1.004 1.004 0 0 0-1.21.736L31.425 17.49H22.79a1 1 0 0 0-1.004.996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.643 15.356h6.412v10.85h-.641a1 1 0 0 0-1.004.995 1 1 0 0 0 1.004.995h1.575q.035.005.07.007.034-.002.07-.007h1.577a1 1 0 0 0 1.003-.995 1 1 0 0 0-1.003-.994h-.643V15.356h6.413a1 1 0 0 0 1.003-.995 1 1 0 0 0-1.003-.995h-5.222c-.165-1.24-.555-2.237-1.036-3.024.388-.32.87-.607 1.465-.834a.993.993 0 0 0 .576-1.286c-.2-.512-.78-.768-1.298-.57a7.2 7.2 0 0 0-2.02 1.154c-.895-.809-1.717-1.129-1.79-1.156a1.006 1.006 0 0 0-1.294.578.99.99 0 0 0 .584 1.282c.012.005.562.22 1.18.792a6.7 6.7 0 0 0-.993 3.065h-4.985a1 1 0 0 0-1.004.995 1 1 0 0 0 1.004.994m7.263-3.15c.135.346.246.732.321 1.16h-.582a4.8 4.8 0 0 1 .26-1.16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHome);
export default __webpack_public_path__ + "static/media/footerHome.3ad3b73a59326bdfd1896bdbb8d03cce.svg";
export { ForwardRef as ReactComponent };